import React, { useState, useContext, useEffect } from 'react';
import {IProps, IState, IMultiEditingFieldsProps, IMultiEditingPickerAttribute} from './types';
import * as S from './styles';
import { Context } from "routes/private/Editor/Context";
import MultiEditingAttributes from './attributes';
import {IMultiEditingConfig} from 'state/dsconfig/types';
import NotHiddenIcon from '@assets/icons/notHiddenIcon';
import HiddenIcon from '@assets/icons/hiddenIcon';
import { allHidden } from 'utils/multiEditing';
import {getTaggedVisibleElementsId} from 'utils/selectDescribe'

const MultiEditingFields:React.FC<IMultiEditingFieldsProps> = (props) => {
  let context = useContext(Context);
  const [hidden, setHidden] = useState(allHidden(props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields));
  const [elementsId, setElementsId] = useState(((!context.selectDescribe?.taggedFields)?[]:getTaggedVisibleElementsId([props.selectDescribeFieldId],context.selectDescribe?.taggedFields!,context.data)));
  const [attributes,setAttributes] = useState<IMultiEditingPickerAttribute[]>([]);
  
  useEffect(() => {
    if (context.multiEditingConfig) {
      const attributesPicker = getMultiEditingAttributesForPicker(context.multiEditingConfig);
      setAttributes(attributesPicker);
    }
  }, [props.id])

  useEffect(() => {
    setHidden(allHidden(props.selectDescribeFieldId,context.data,context.selectDescribe?.taggedFields));
    setElementsId(((!context.selectDescribe?.taggedFields)?[]:getTaggedVisibleElementsId([props.selectDescribeFieldId],context.selectDescribe?.taggedFields!,context.data)));
  }, [props.selectDescribeFieldId, context.data,context.selectDescribe?.taggedFields])

  const getMultiEditingAttributesForPicker = (multiEditingConfig: IMultiEditingConfig): IMultiEditingPickerAttribute[] => {
    let fieldAttributes: IMultiEditingPickerAttribute[] = [];  
    for(let i=0;i<multiEditingConfig.categories.length;i++){
        if(multiEditingConfig.categories[i].id===props.categoryId) {
          for(let a=0;a<multiEditingConfig.categories[i].fields.length;a++){
            if(multiEditingConfig.categories[i].fields[a].id===props.id) {
              fieldAttributes = multiEditingConfig.categories[i].fields[a].attributes.map((attribute) => { return {categoryId: props.categoryId, categoryName:props.name, fieldId: props.id, elementType: props.elementType, selectDescribeFieldId: props.selectDescribeFieldId, name: attribute.name, label: attribute.label, dataType: attribute.dataType, control: attribute.control, validation: attribute.validation, formating: attribute.formating}});
              break;
            }
          }
        }
    }
    return fieldAttributes;
  }
  
  return (
    <S.FieldRow>
        <S.FieldTitle>
            {
                props.name
            }
            <S.VisibilityIconContainer onClick={() => context.onCommandChange("hideUnhide", (!hidden).toString(), elementsId, undefined, undefined, undefined, undefined, 'MULTIEDITOR_PICKER')}>
            {hidden ? 
              <HiddenIcon stroke="#97A6C0" style={{overflow: 'inherit', marginLeft: 'auto', marginRight: '18px', cursor: 'pointer'}}/> 
              : 
              <NotHiddenIcon stroke="#97A6C0" style={{overflow: 'inherit', marginLeft: 'auto', marginRight: '18px', cursor: 'pointer'}}/>
            }
            </S.VisibilityIconContainer>
        </S.FieldTitle>
        {
          attributes.map((attribute, index) => {
            return (
              <MultiEditingAttributes
                key={index}
                categoryId={attribute.categoryId}
                categoryName={attribute.categoryName}
                fieldId={attribute.fieldId}
                elementType={props.elementType}
                selectDescribeFieldId={attribute.selectDescribeFieldId}
                name={attribute.name}
                label={attribute.label}
                dataType={attribute.dataType}
                control={attribute.control}
                validation={attribute.validation}
                formating={attribute.formating}
              />
            )
          })
        }
    </S.FieldRow>
  );
}

export default MultiEditingFields;